<template>
  <div class="help-center-container">
    <div class="help-center-title">
      <span class="title">帮助中心</span>
      <a :href="helpData.more" class="more" target="_blank"
        @mouseenter="hoverImg = true"
        @mouseleave="hoverImg = false">
        更多
        <img src="../../../static/images/icon/login-icon/help_more_hover.svg"
          v-if="hoverImg">
        <img src="../../../static/images/icon/login-icon/help_more.svg"
          v-else>
      </a>
    </div>
    <div class="help-center-content">
      <div v-for="content in listData" class="content"
        @mouseenter="content.detailHover = true"
        @mouseleave="content.detailHover = false"
        @click="go2Link(content)">
        <img class="icon" :src="content.icon">
        <span class="content-title">{{content.title}}</span>
        <span class="detail">
          查看详情
          <img class="help_more" src="../../../static/images/icon/login-icon/help_more_hover.svg"
            v-if="content.detailHover">
          <img class="help_more" src="../../../static/images/icon/login-icon/help_more.svg"
            v-else>
        </span>
      </div>
      <section class="vertical-line"></section>
    </div>
  </div>
</template>

<style scoped lang="scss">
  @import './help-center.scss'
</style>

<script>
  // export { default } from './help-center.js'
  export default {
    data () {
      return {
        hoverImg: false,
        contents: [{
          title: '新手入门',
          icon: require('../../../static/images/icon/login-icon/help_center_start.svg'),
          link: 'https://school.oceanengine.com/course/6815163648198049799/?visitor_source=ad_source&location=ad&round=ad_loginpage_help_xinshourumen',
          detailHover: false
        }, {
          title: '平台介绍',
          icon: require('../../../static/images/icon/login-icon/help-center-platform-intro.svg'),
          link: 'https://school.oceanengine.com/product_help/content/668400000006/112866?from=from_parent_mindnote',
          detailHover: false
        }, {
          title: '创建广告',
          icon: require('../../../static/images/icon/login-icon/help_center_create_ad.svg'),
          link: 'https://school.oceanengine.com/help?category_id=6392839098997932033/?visitor_source=ad_source&location=ad&round=ad_loginpage_help_chuanjianguanggao',
          detailHover: false
        }, {
          title: '效果评估',
          icon: require('../../../static/images/icon/login-icon/help_center_effect_evaluation.svg'),
          link: 'https://school.oceanengine.com/help?article_id=6727070997922447368/?visitor_source=ad_source&location=ad&round=ad_loginpage_help_xiaoguopinggu',
          detailHover: false
        }, {
          title: '效果优化',
          icon: require('../../../static/images/icon/login-icon/help_center_effect_optimization.svg'),
          link: 'https://school.oceanengine.com/help?article_id=6446541622128672781/?visitor_source=ad_source&location=ad&round=ad_loginpage_help_xiaoguoyouhua',
          detailHover: false
        }, {
          title: '广告审核',
          icon: require('../../../static/images/icon/login-icon/help_center_audit_related.svg'),
          link: 'https://school.oceanengine.com/help?article_id=6794349984427802638/?visitor_source=ad_source&location=ad&round=ad_loginpage_help_guanggaoshenhe',
          detailHover: false
        }, {
          title: '流量变现',
          icon: require('../../../static/images/icon/login-icon/help_center_traffic_realisation.svg'),
          link: 'https://school.oceanengine.com/help/?article_id=6631793406697799687/?visitor_source=ad_source&location=ad&round=ad_loginpage_help_liuliangbianxian',
          detailHover: false
        }, {
          title: '常见问题',
          icon: require('../../../static/images/icon/login-icon/help_center_common_question.svg'),
          link: 'https://school.oceanengine.com/help?article_id=6394276152130666498/?visitor_source=ad_source&location=ad&round=ad_loginpage_help_changjianwenti',
          detailHover: false
        }]
        // {
        //   title: '活动专区',
        //   icon: require('../../../static/images/icon/login-icon/help_center_activity.svg'),
        //   link: 'https://ad.toutiao.com/academy/help/?category_id=6618815476577337352'
        // }, {
        //   title: '渠道合作商专区',
        //   icon: require('../../../static/images/icon/login-icon/help_center_channel_partners_area.svg'),
        //   link: 'https://ad.toutiao.com/academy/help/?category_id=6582107363124183044'
        // }
      }
    },
    props: {
      helpData: {
        type: Object,
        default () {
          return {
            items: [],
            more: 'https://ad.toutiao.com/academy/help/'
          }
        }
      }
    },
    computed: {
      listData () {
        return this.contents.map(content => {
          let isInclude = this.helpData.items.some(item => {
            if (content.title === item.title) {
              // content.link = item.link
              return true
            }
          })
          return content
        })
      }
    },
    mounted () {
    },
    methods: {
      go2Link (content) {
        window.open(content.link)
      }
    }
  }
</script>
